import { GLOBAL_MEM_FAILURE, GLOBAL_MEM_REQUEST, GLOBAL_MEM_SUCCESS, LIST_GLOBAL_MEM_DOCS_FAILURE, LIST_GLOBAL_MEM_DOCS_REQUEST, LIST_GLOBAL_MEM_DOCS_SUCCESS, LIST_GLOBAL_MEM_FAILURE, LIST_GLOBAL_MEM_REQUEST, LIST_GLOBAL_MEM_SUCCESS } from "../../actions/memory/globalMemoryActions";

  const initialState = {
    globalMemDataLoading: false,
    globalMemData: [],
    globalMemDataError: null,
  };


  const initialListState={
    listGlobalMemDataLoading: false,
    listGlobalMemData: [],
    listGlobalMemDataError: null,
  }


  const initialListMemDocState={
    listGlobalMemDocDataLoading: false,
    listGlobalMemDocData: [],
    listGlobalMemDocDataError: null,
  }




  
  export const globalMemDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case GLOBAL_MEM_REQUEST:
        return { ...state, globalMemDataLoading: true , payload: action.payload};
      case GLOBAL_MEM_SUCCESS:
        return { ...state, globalMemDataLoading: false, globalMemData: action.payload };
      case GLOBAL_MEM_FAILURE:
        return { ...state, globalMemDataLoading: false, globalMemDataError: action.payload };       
      default:
        return state;
    }
  };
  



    
  export const listGlobalMemDataReducer = (state = initialListState, action) => {
    switch (action.type) {
      case LIST_GLOBAL_MEM_REQUEST:
        return { ...state, listGlobalMemDataLoading: true , payload: action.payload};
      case LIST_GLOBAL_MEM_SUCCESS:
        return { ...state, listGlobalMemDataLoading: false, listGlobalMemData: action.payload };
      case LIST_GLOBAL_MEM_FAILURE:
        return { ...state, listGlobalMemDataLoading: false, listGlobalMemDataError: action.payload };       
      default:
        return state;
    }
  };



  export const listGlobalMemDocDataReducer = (state = initialListMemDocState, action) => {
    switch (action.type) {
      case LIST_GLOBAL_MEM_DOCS_REQUEST:
        return { ...state, listGlobalMemDocDataLoading: true , payload: action.payload};
      case LIST_GLOBAL_MEM_DOCS_SUCCESS:
        return { ...state, listGlobalMemDocDataLoading: false, listGlobalMemDocData: action.payload };
      case LIST_GLOBAL_MEM_DOCS_FAILURE:
        return { ...state, listGlobalMemDocDataLoading: false, listGlobalMemDocDataError: action.payload };       
      default:
        return state;
    }
  };




  

   
